import { ProjectSchema, type Project } from "@tasduvar/engine";
import { summarize, type ProjectStore, type ProjectSummary } from "./types";

const PREFIX = "tasduvar:project:";

export class LocalStorageProjectStore implements ProjectStore {
  private keys(): string[] { return Object.keys(window.localStorage).filter((k) => k.startsWith(PREFIX)); }
  private read(key: string): Project | null {
    try { const raw = window.localStorage.getItem(key); return raw ? ProjectSchema.parse(JSON.parse(raw)) : null; } catch { return null; }
  }
  async list(): Promise<ProjectSummary[]> {
    return this.keys().map((k) => this.read(k)).filter((p): p is Project => p !== null).map(summarize).sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
  }
  async load(id: string): Promise<Project | null> { return this.read(PREFIX + id); }
  async save(p: Project): Promise<void> { window.localStorage.setItem(PREFIX + p.id, JSON.stringify({ ...p, updatedAt: new Date().toISOString() })); }
  async remove(id: string): Promise<void> { window.localStorage.removeItem(PREFIX + id); }
}
